import api, { PublicRequest } from 'api/Assessor/parametros';
import {
  BrowseIcon,
  CheckIcon,
  ErrorIcon,
  LockIcon,
  PlusIcon,
} from 'components/Icons';
import Loading from 'components/Modal/__LEGACY__/AbrirVotacaoPautaModal/Loading';
import ErrorHandler from 'helpers/utils/ErrorHandler';
import translation from 'locales/translation';
import {
  Button,
  ButtonThemes,
  Collapse,
  Input,
  InputArea,
} from 'plataforma-fundacao-componentes';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { parametroAssessorResultadoPadrao } from 'store/modules/AssembleiasAssessorActions';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { IModalProps } from '../../../../store/modules/ModalsReducer';
import GenericModal, { IGenericModalProps } from '../GenericModal/GenericModal';
import EditableItem from './componentes/EditableItem/EditableItem';
import './styles.scss';
const rootClassName = 'resposta-padrao-modal';

export interface RespostaPadraoModalProps extends IGenericModalProps {
  key?: string;
  codCoop?: any;
  idParametroCoop?: number;
}

export interface IRespostaPadraoModalProps extends IModalProps {
  genericProps?: RespostaPadraoModalProps;
}

export default function RespostaPadraoModal({
  genericProps,
  open,
}: IRespostaPadraoModalProps) {
  const [respostaPadrao, setRespostaPadrao] = useState<any>();
  const [valueAssunto, setValueAssunto] = useState<string>('');
  const [valueMessage, setValueMessage] = useState<string>('');
  const [publicValue, setPublicValue] = useState<string>();
  const [opened, setOpened] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  const dispatch = useDispatch();

  const toClose = useCallback((): void => {
    if (genericProps && genericProps.key) {
      dispatch(modalsActionsClose(genericProps.key));
    }
  }, [dispatch, genericProps]);

  const publicState = useCallback(async (dataSend: PublicRequest) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { fail } = await api.isPublic(dataSend);
    if (fail) {
      ErrorHandler(fail);
    }
  }, []);

  useEffect(() => {
    if (!respostaPadrao) {
      dispatch(
        parametroAssessorResultadoPadrao(
          genericProps?.codCoop,
          (response: any) => {
            setRespostaPadrao({
              idParametroCoop: genericProps?.idParametroCoop,
              data: response,
            });
            setPublicValue(String(response.publico));
            setLoading(false);
          }
        )
      );
    }
  }, [dispatch, genericProps, respostaPadrao]);

  const canSubmit = useCallback(() => {
    if (
      valueAssunto === null ||
      valueMessage === null ||
      !valueAssunto ||
      !valueMessage
    )
      return false;
    if (!valueAssunto.trim() || !valueMessage.trim()) return false;
    return true;
  }, [valueAssunto, valueMessage]);

  const handleSubmit = useCallback(
    // eslint-disable-next-line unused-imports/no-unused-vars
    async (event: React.FormEvent<HTMLFormElement>) => {
      if (!canSubmit) return;
      setLoading(true);
      const { fail, data } = await api.adicionarRespostaPadrao({
        codigoCooperativa: genericProps?.codCoop,
        assunto: valueAssunto.replace(/\r?\n|\r/g, ' '),
        mensagem: valueMessage.replace(/\r?\n|\r/g, ' '),
      });

      setValueAssunto('');
      setValueMessage('');
      setLoading(false);
      if (fail) {
        ErrorHandler(fail);
        setValueAssunto('');
        setValueMessage('');
      }
      if (data) {
        dispatch(
          parametroAssessorResultadoPadrao(
            genericProps?.codCoop,
            (response: any) => {
              setRespostaPadrao({
                idParametroCoop: genericProps?.idParametroCoop,
                data: response,
              });
            }
          )
        );
        setOpened(false);
      }
    },
    [canSubmit, dispatch, genericProps, valueAssunto, valueMessage]
  );

  const handleDelete = useCallback(async (id: number) => {
    setLoading(true);
    const { fail } = await api.removerRespostaPadrao(id);
    setLoading(false);
    if (fail) {
      ErrorHandler(fail);
    }
  }, []);

  const handleEdit = useCallback(
    async (id: number, assunto: string, mensagem: string) => {
      const { fail } = await api.alterarRespostaPadrao({
        id: id,
        assunto: assunto.replace(/\r?\n|\r/g, ' '),
        mensagem: mensagem.replace(/\r?\n|\r/g, ' '),
      });

      if (fail) {
        ErrorHandler(fail);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [valueAssunto, valueMessage]
  );

  return (
    <GenericModal
      open={open ?? false}
      title={translation.Parâmetros.modalResultadoPadrao.titulo}
      content={
        loading ? (
          <Loading inline />
        ) : (
          <div className={rootClassName}>
            <div className={`${rootClassName}-publica-privada-container`}>
              {
                translation.Parâmetros.modalResultadoPadrao
                  .respostaPublicaOuPrivada
              }
              <div className={`${rootClassName}-radio-group`}>
                <input
                  checked={publicValue === 'true' ? true : false}
                  value={String(true)}
                  type='radio'
                  id='public'
                  name='selector'
                  onChange={(e) => {
                    setPublicValue(e.target.value);
                    publicState({
                      idParametro: respostaPadrao?.idParametroCoop,
                      publico: e.target.value === 'true' && true,
                    });
                  }}
                />
                <label htmlFor='public'>
                  <BrowseIcon />
                </label>
                <input
                  checked={publicValue === 'false' ? true : false}
                  value={String(false)}
                  type='radio'
                  id='private'
                  name='selector'
                  onChange={(e) => {
                    setPublicValue(e.target.value);
                    publicState({
                      idParametro: respostaPadrao?.idParametroCoop,
                      publico: e.target.value === 'false' && false,
                    });
                  }}
                />
                <label htmlFor='private'>
                  <LockIcon />
                </label>
              </div>
            </div>
            <Collapse opened={!opened}>
              <Button
                onClick={() => {
                  setValueAssunto('');
                  setValueMessage('');
                  setOpened(!opened);
                }}
                leftIcon={<PlusIcon />}
                theme={ButtonThemes.Primary}
              >
                {translation.Parâmetros.modalResultadoPadrao.adicionarResposta}
              </Button>
              {!respostaPadrao ||
              !respostaPadrao?.data?.respostasPadroes?.length ? (
                <div className={`${rootClassName}-sem-respostas`}>
                  {translation.Parâmetros.modalResultadoPadrao.semRespostas}
                </div>
              ) : (
                <>
                  <hr className={`${rootClassName}-divider`} />
                  {respostaPadrao?.data?.respostasPadroes?.map((resp: any) => {
                    return (
                      <EditableItem
                        key={resp.id}
                        assunto={resp.assunto}
                        message={resp.mensagem}
                        assuntoProps={{
                          placeholder:
                            translation.Parâmetros.modalResultadoPadrao
                              .placeholderAssunto,
                          maxLength: 100,
                          validations: [
                            (assunto) => {
                              if (assunto.length === 0) {
                                return {
                                  error: true,
                                  helperText: 'Esse campo é obrigatório',
                                };
                              } else if (assunto.length > 100) {
                                return {
                                  error: true,
                                  helperText: 'Máximo 100 caracteres',
                                };
                              }
                              return { error: false };
                            },
                          ],
                        }}
                        messageProps={{
                          placeholder:
                            translation.Parâmetros.modalResultadoPadrao
                              .placeholderMensagem,
                          maxLength: 500,
                          validations: [
                            (message) => {
                              if (message.trim().length === 0) {
                                return {
                                  error: true,
                                  helperText: 'Esse campo é obrigatório',
                                };
                              } else if (message.length > 500) {
                                return {
                                  error: true,
                                  helperText: 'Máximo 500 caracteres',
                                };
                              }
                              return { error: false };
                            },
                          ],
                        }}
                        onEditConfirm={(assunto: string, mensagem: string) => {
                          return new Promise(
                            (
                              resolve: (evt?: any) => void,
                              reject: () => void
                            ) => {
                              handleEdit(resp.id!, assunto, mensagem)
                                .then(() => {
                                  setValueAssunto(assunto);
                                  setValueMessage(mensagem);
                                  resolve();
                                })
                                .catch(() => {
                                  reject();
                                });
                            }
                          );
                        }}
                        onRemoveClick={() => {
                          return new Promise(
                            (
                              resolve: (evt?: any) => void,
                              reject: () => void
                            ) => {
                              handleDelete(resp.id!)
                                .then(() => {
                                  resolve();
                                  dispatch(
                                    parametroAssessorResultadoPadrao(
                                      genericProps?.codCoop,
                                      (response: any) => {
                                        setRespostaPadrao({
                                          idParametroCoop:
                                            genericProps?.idParametroCoop,
                                          data: response,
                                        });
                                      }
                                    )
                                  );
                                })
                                .catch(() => {
                                  reject();
                                });
                            }
                          );
                        }}
                      />
                    );
                  })}
                </>
              )}
            </Collapse>
            <Collapse opened={opened}>
              <div className={`${rootClassName}-adicionar-resposta-container`}>
                <Input
                  value={valueAssunto.replace(/\r?\n|\r/g, ' ')}
                  onChange={(evt) => setValueAssunto(evt.target.value)}
                  label={
                    translation.Parâmetros.modalResultadoPadrao.inputAssunto
                  }
                  placeholder={
                    translation.Parâmetros.modalResultadoPadrao
                      .placeholderAssunto
                  }
                  counter
                  maxLength={100}
                />
                <InputArea
                  value={valueMessage.replace(/\r?\n|\r/g, ' ')}
                  onChange={(evt) => setValueMessage(evt.target.value)}
                  label={
                    translation.Parâmetros.modalResultadoPadrao.inputMensagem
                  }
                  placeholder={
                    translation.Parâmetros.modalResultadoPadrao
                      .placeholderMensagem
                  }
                  counter
                  maxLength={500}
                />
                <div className={`${rootClassName}-buttons-container`}>
                  <Button
                    onClick={() => setOpened(!opened)}
                    leftIcon={<ErrorIcon />}
                    theme={ButtonThemes.Secondary}
                  >
                    {translation.Parâmetros.modalResultadoPadrao.botaoCancelar}
                  </Button>
                  <Button
                    type={'submit'}
                    leftIcon={<CheckIcon />}
                    theme={ButtonThemes.Primary}
                    onClick={() => {
                      handleSubmit(genericProps?.codCoop);
                    }}
                    disabled={!canSubmit()}
                    loading={loading}
                  >
                    {translation.Parâmetros.modalResultadoPadrao.botaoSalvar}
                  </Button>
                </div>
              </div>
            </Collapse>
          </div>
        )
      }
      genericProps={{
        maxWidth: 'sm',
        onClose: toClose,
      }}
    />
  );
}
